/**
 * This will create an attribute object.
 *
 * @param {string} key
 * @param {*} value
 * @returns {object}
 */
export const Attribute = (key, value) =>
{
    return {
        key,
        value
    };
};